import Combo from '@onehat/ui/src/Components/Form/Field/Combo/Combo.js';
import {
	GROUPS__CLIENTS,
} from '../../../../constants/Groups.js';

function ClientsCombo(props) {
	return <Combo
				reference="clientsCombo"
				model="Users"
				uniqueRepository={true}
				baseParams={{
					'conditions[groups_users__group_id]': GROUPS__CLIENTS,
					leftJoinWith: 'GroupsUsers',
				}}
				{...props}
			/>;
}

export default ClientsCombo;